(ns frontend.view.modals.entry-criteria.view
  (:require
   [ui.view.entry-criteria.view :as entry-criteria]))

;; Note: modal-key in frontend.view.modals.custom-entity-creator.model
;; to prevent circular dependencies

(defn view
  [props]
  [entry-criteria/modal-view props])
